<template>
  <button :class="$style.close" @click="$emit('click')" />
</template>

<script>
export default {
  name: "BtnClose"
};
</script>

<style module lang="less">
.close {
  .size(0.7rem);
  .background-fill("./images/close.png");
}
</style>
